import { useCallback } from 'react';
import axios from 'axios';
import { useCalculatorStore } from '../store/calculatorStore';
import type { ProjectSchema, ProjectListItem } from '../types';

const API_BASE = '/api';

export function useProjects() {
  const listProjects = useCallback(async (): Promise<ProjectListItem[]> => {
    const r = await axios.get<{ projects: ProjectListItem[] }>(`${API_BASE}/projects`);
    return r.data.projects;
  }, []);
  return { listProjects };
}

export function useSchema() {
  const schema = useCalculatorStore((s) => s.schema);
  return schema;
}

export async function fetchProjectSchema(projectId: string): Promise<ProjectSchema> {
  const r = await axios.get<ProjectSchema>(`${API_BASE}/projects/${projectId}/schema`);
  return r.data;
}
